import GroupIcon from '@mui/icons-material/Group'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import EmergencyShareIcon from '@mui/icons-material/EmergencyShare'
import InsightsIcon from '@mui/icons-material/Insights'
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded'
import AssessmentIcon from '@mui/icons-material/Assessment'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import Business from '@mui/icons-material/Business'
import NotificationsIcon from '@mui/icons-material/Notifications'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'

export const SideNavItems = {
    app: 'dashboard',
    modules: [
        {
            items: [
                {
                    path: '/dashboard',
                    page: 'Dashboard'
                }
            ],
            icon: <BarChartRoundedIcon />,
            name: 'Dashboard'
        },
        {
            items: [
                {
                    path: '/dashboard/analytics',
                    page: 'Visão geral'
                },
                {
                    path: '/dashboard/analytics/workshops',
                    page: 'Oficinas'
                },
                {
                    path: '/dashboard/analytics/users',
                    page: 'Usuários'
                },
                {
                    path: '/dashboard/analytics/reminders',
                    page: 'Lembretes'
                },
                {
                    path: '/dashboard/analytics/maintenance',
                    page: 'Manutenção'
                },
                {
                    path: '/dashboard/analytics/loyalty',
                    page: 'Fidelidade'
                },
                {
                    path: '/dashboard/analytics/campaigns',
                    page: 'Campanhas'
                },
                {
                    path: '/dashboard/analytics/events',
                    page: 'Eventos'
                },
                {
                    path: '/dashboard/analytics/system',
                    page: 'Sistema'
                }
            ],
            icon: <AssessmentIcon />,
            name: 'Análises',
            requiresSuperAdmin: true
        },
        {
            items: [
                {
                    path: '/dashboard/clientes',
                    page: 'Página de Clientes'
                }
            ],
            icon: <GroupIcon />,
            name: 'Clientes'
        },
        {
            items: [
                {
                    path: '/dashboard/mecânicas',
                    page: 'Página de Estabelecimentos'
                }
            ],
            icon: <Business />,
            name: 'Estabelecimentos'
        },
        {
            items: [
                {
                    path: '/dashboard/promoções',
                    page: 'Página de Promoções'
                }
            ],
            icon: <InsightsIcon />,
            name: 'Promoções'
        },
        {
            items: [
                {
                    path: '/dashboard/notificações',
                    page: 'Notificações'
                }
            ],
            icon: <NotificationsIcon />,
            name: 'Notificações'
        },
        {
            items: [
                {
                    path: '/dashboard/ofertas',
                    page: 'Ofertas de Atividades'
                }
            ],
            icon: <LocalOfferIcon />,
            name: 'Ofertas'
        },
        {
            items: [
                {
                    path: '/dashboard/preços-postos-de-gasolina',
                    page: 'Página de Preços dos Postos de Gasolina'
                }
            ],
            icon: <LocalGasStationIcon />,
            name: 'Preços Postos'
        },
        {
            items: [
                {
                    path: '/dashboard/indicações',
                    page: 'Indicações'
                }
            ],
            icon: <EmergencyShareIcon />,
            name: 'Indicações'
        },
        {
            items: [
                {
                    path: '/dashboard/auditoria',
                    page: 'Auditoria'
                }
            ],
            icon: <ManageSearchIcon />,
            name: 'Auditoria'
        }
    ]
}
